import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Publications = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const content = {
    English: {
      title: "Publication",
      breadcrumb: {
        home: "HOME",
        page: "PUBLICATION",
      },
      paragraph: `The Directorate of Archaeology and Museums carries out various programs to generate public awareness and interest. Publication of project reports, books as well as reports and articles on the  on-going works are few of the tasks undertaken by the Directorate to familiarise people with their work. These publications entail various types such as those in the form of printed Brochures, Booklets, Guide Books, Articles and Reports and are published by the Directorate.`},
    मराठी: {
      title: "प्रकाशने",
      breadcrumb: {
        home: "मुख्यपृष्ठ ",
        page: "प्रकाशने",
      },
      paragraph: `पुरातत्त्व व वस्तुसंग्रहालये संचालनालय हे जनजागृती आणि जनसंपर्क वाढवण्यासाठी विविध कार्यक्रम राबवते. प्रकल्प अहवालांचे प्रकाशन आणि सध्या सुरू असलेली कामे यांचे अहवाल, पुस्तिका, लेख इत्यादी कार्य सुद्धा संचालनालय करते ज्यामुळे नागरिकांना संचालनालय करत असलेल्या कामाबद्दल व्यवस्थित माहिती मिळते. संचालनालयाच्या प्रकाशनांमध्ये विविध प्रकारांचा समावेश आहे जसे की छापील माहितीपत्रके, पुस्तिका, मार्गदर्शक पुस्तके, लेख आणि अहवाल इत्यादी जे सर्व संचालनालयाद्वारे प्रकाशित केले जातात.`
    },
  };

  const tableHeaders = {
    heading: {
      English: "Guide Book",
      मराठी: "मार्गदर्शिका",
    },
    Name: {
      English: "Name",
      मराठी: "नाव",
    },
    Author: {
      English: "Author",
      मराठी: "लेखक",
    },
    Language: {
      English: "Language",
      मराठी: "भाषा",
    },
    Year: {
      English: `Year`,
      मराठी: `वर्ष`,
    },
  };
  const t = content[selectedLang];

  const guidebookData = [
    {
      id: 1,
      Name: {
        English: "Rajgad Darshan",
        मराठी: "राजगड दर्शन",
      },
      Author: {
        English: "Dr. P. N. Deshpande",
        मराठी: "डॉ. प्र. न. देशपांडे",
      },
      Language: {
        English: "Marathi",
        मराठी: "मराठी",
      },
      Year: {
        English: "1981",
        मराठी: "१९८१",
      },
    },
    {
      id: 2,
      Name: {
        English: "Junnar Shivneri Parisar",
        मराठी: "जुन्नर शिवनेरी परिसर",
      },
      Author: {
        English: "Dr. Suresh Jadhav",
        मराठी: "डॉ. सुरेश जाधव",
      },
      Language: {
        English: "Marathi",
        मराठी: "मराठी",
      },
      Year: {
        English: "1982",
        मराठी: "१९८२",
      },
    },
    {
      id: 3,
      Name: {
        English: "SindkhedRaja",
        मराठी: "सिंदखेड राजा",
      },
      Author: {
        English: "Vijay Deshmukh",
        मराठी: "विजय देशमुख",
      },
      Language: {
        English: "Marathi",
        मराठी: "मराठी",
      },
      Year: {
        English: "1982",
        मराठी: "१९८२",
      },
    },
    {
      id: 4,
      Name: {
        English: "Sinhgad",
        मराठी: "सिंहगड",
      },
      Author: {
        English: "Dr. G. H. Khare",
        मराठी: "डॉ. ग. ह. खरे",
      },
      Language: {
        English: "Marathi",
        मराठी: "मराठी",
      },
      Year: {
        English: "1984",
        मराठी: "१९८४",
      },
    },
    {
      id: 5,
      Name: {
        English: "Samrthancha Sajjangad",
        मराठी: "समर्थांचा सज्जनगड",
      },
      Author: {
        English: "Dr. P. K. Ghanekar",
        मराठी: "डॉ. प्र. के. घाणेकर",
      },
      Language: {
        English: "Marathi",
        मराठी: "मराठी",
      },
      Year: {
        English: "1984",
        मराठी: "१९८४",
      },
    },
    {
      id: 6,
      Name: {
        English: "Paithan Darshan",
        मराठी: "पैठण दर्शन",
      },
      Author: {
        English: "Dr. R. S. Morvanchikar",
        मराठी: "डॉ. रा. श्री. मोरवंचीकर",
      },
      Language: {
        English: "Marathi",
        मराठी: "मराठी",
      },
      Year: {
        English: "1985",
        मराठी: "१९८५",
      },
    },
    {
      id: 7,
      Name: {
        English: "Sindhudurg Darshan",
        मराठी: "सिंधुदुर्ग दर्शन",
      },
      Author: {
        English: "Dr. P. K. Ghanekar and A. P. Kamat",
        मराठी: "डॉ. प्र. के. घाणेकर आणि ए. पी. कामत",
      },
      Language: {
        English: "Marathi",
        मराठी: "मराठी",
      },
      Year: {
        English: "1985",
        मराठी: "१९८५",
      },
    },
    {
      id: 8,
      Name: {
        English: "Kandhar: ek aitihasik shahar",
        मराठी: "कंधार एक ऐतिहासिक शहर",
      },
      Author: {
        English: "Dr. P. Deo",
        मराठी: "डॉ. प्रभाकर देव",
      },
      Language: {
        English: "Marathi",
        मराठी: "मराठी",
      },
      Year: {
        English: "1985",
        मराठी: "१९८५",
      },
    },
    {
      id: 9,
      Name: {
        English: "Nashik Darshan",
        मराठी: "नाशिक दर्शन",
      },
      Author: {
        English: "Dr. R. S. Morvanchikar",
        मराठी: "डॉ. रा. श्री. मोरवंचीकर",
      },
      Language: {
        English: "Marathi",
        मराठी: "मराठी",
      },
      Year: {
        English: "1994",
        मराठी: "१९९४",
      },
    },
    {
      id: 10,
      Name: {
        English: "Pandharpur Darshan",
        मराठी: "पंढरपूर दर्शन",
      },
      Author: {
        English: "Dr. M. S. Mate",
        मराठी: "डॉ. म. श्री. माटे",
      },
      Language: {
        English: "Marathi",
        मराठी: "मराठी",
      },
      Year: {
        English: "1994",
        मराठी: "१९९४",
      },
    },
    {
      id: 11,
      Name: {
        English: "Devdgiri",
        मराठी: "देवगिरी",
      },
      Author: {
        English: "Dr. G. B. Deglurkar",
        मराठी: "डॉ. गो. बं. देगलूरकर",
      },
      Language: {
        English: "Marathi",
        मराठी: "मराठी",
      },
      Year: {
        English: "1999",
        मराठी: "१९९९",
      },
    }
  ];

  const archaeology = [
    {
      Name: {
        English: 'Mumbai Parisaratil Arthat Ekkekalchy Firanganatil Killhe',
        मराठी: 'मुंबई परिसरतील अर्थत एकेकळच फिरंगणातिल किल्ले',
      },
      Author: {
        English: 'Shri. B. V. Kulkarni',
        मराठी: 'श्री. बी. व्ही. कुलकर्णी',
      },
      Language: {
        English: 'Marathi',
        मराठी: 'मराठी',
      },
      Year: {
        English: '2009',
        मराठी: '२००९',
      },
    },
    {
      Name: {
        English: 'Maharashtra Archaeology Annual Report',
        मराठी: 'महाराष्ट्र पुरातत्त्व वार्षिक अहवाल',
      },
      Author: {
        English: 'Director of Archaeology',
        मराठी: 'पुरातत्व संचालक',
      },
      Language: {
        English: 'Marathi',
        मराठी: 'मराठी',
      },
      Year: {
        English: '2003-04',
        मराठी: '२००३-०४',
      },
    },
    {
      Name: {
        English: 'Bhartiy Purattav',
        मराठी: 'भारतीय पुरातत्त्व',
      },
      Author: {
        English: 'Dr. H. D. Sankalia',
        मराठी: 'डॉ. एच. डी. सांकलिया',
      },
      Language: {
        English: 'Marathi',
        मराठी: 'मराठी',
      },
      Year: {
        English: '1989',
        मराठी: '१९८९',
      },
    },
    {
      Name: {
        English: 'Ter',
        मराठी: 'तेर',
      },
      Author: {
        English: 'Dr. S. B. Deo',
        मराठी: 'डॉ. एस. बी. देव',
      },
      Language: {
        English: 'Marathi',
        मराठी: 'मराठी',
      },
      Year: {
        English: '-',
        मराठी: '-',
      },
    },
  ];

  const excavation = [
    {
      Name: {
        English: 'Kaudinyapur Excavation',
        मराठी: 'कौंडिण्यपूर उत्खनन',
      },
      Author: {
        English: 'Dr. M. G. Dikshit',
        मराठी: 'डॉ. एम. जी. दीक्षित',
      },
      Language: {
        English: 'English',
        मराठी: 'इंग्रजी',
      },
      Year: {
        English: '1968',
        मराठी: '१९६८',
      },
    },
    {
      Name: {
        English: 'Naikund Excavation',
        मराठी: 'नायकुंड उत्खनन',
      },
      Author: {
        English: 'Dr. S. B. Deo and Dr. A. P. Jamkhedkar',
        मराठी: 'डॉ. एस. बी. देव व डॉ. ए. पी. जामखेडकर',
      },
      Language: {
        English: 'English',
        मराठी: 'इंग्रजी',
      },
      Year: {
        English: '1982',
        मराठी: '१९८२',
      },
    },
  ];

  const others = [
    {
      Name: {
        English: 'Chandrakant Mandhare',
        मराठी: 'चंद्रकांत मांडरे',
      },
      Author: {
        English: 'Surykant Mandhare and Chandrakant Nande',
        मराठी: 'सूर्यकांत मांडरे आणि चंद्रकांत नांदे',
      },
      Language: {
        English: 'Marathi',
        मराठी: 'मराठी',
      },
      Year: {
        English: '-',
        मराठी: '-',
      },
    },
    {
      Name: {
        English: 'Shivtirthacya Akhyayika',
        मराठी: 'शिवतीर्थाच्या अख्यायिका',
      },
      Author: {
        English: 'Dr. P. K. Ghanekar',
        मराठी: 'डॉ. पी. के. घाणेकर',
      },
      Language: {
        English: 'Marathi',
        मराठी: 'मराठी',
      },
      Year: {
        English: '1986',
        मराठी: '१९८६',
      },
    },
  ];

  const renderTable = (title, data) => (
    <>
      <h2 className="text-center text-2xl sm:text-3xl md:text-4xl lg:text-4xl mb-8 mt-12">{title}</h2>
      <div className="max-w-5xl mx-auto">
        <div className="bg-[#EFEDE0] overflow-x-auto rounded-xl" style={{ border: "2px solid #F8D6BF" }}>
          <table className="min-w-full text-center text-black text-sm sm:text-base">
            <thead className='font-bold tracking-wide' style={{
              textShadow: '0.3px 0.3px 0 black',
            }}>
              <tr>
                <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                  {tableHeaders.Name[selectedLang]}
                </th>
                <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                  {tableHeaders.Author[selectedLang]}
                </th>
                <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                  {tableHeaders.Language[selectedLang]}
                </th>
                <th className="py-3 px-4" style={{ borderColor: '#F8D6BF' }}>
                  {tableHeaders.Year[selectedLang]}
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.Name[selectedLang]}>
                  <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                    {item.Name[selectedLang]}
                  </td>
                  <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                    {item.Author[selectedLang]}
                  </td>
                  <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                    {item.Language[selectedLang]}
                  </td>
                  <td className="py-3 px-4 border-t-2" style={{ borderColor: '#F8D6BF' }}>
                    {item.Year[selectedLang]}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );


  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-12" >
      {/* Page Title and Breadcrumb */}
      < div className="text-center mb-8" >
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb.home}
            </Link>{" "}/{" "}</span>
          {t.breadcrumb.page}
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-2 sm:px-6 md:px-12 lg:px-20 text-justify text-black leading-relaxed space-y-4 mt-12">
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] font-futura">
          {t.paragraph}
        </p>
      </div>


      {/* Table Section */}

      {renderTable(selectedLang === 'मराठी' ? 'मार्गदर्शिका' : 'Guide Book', guidebookData)}
      {renderTable(selectedLang === 'मराठी' ? 'पुरातत्त्व' : 'Archaeology', archaeology)}
      {renderTable(selectedLang === 'मराठी' ? 'उत्खनन' : 'Excavation', excavation)}
      {renderTable(selectedLang === 'मराठी' ? 'इतर' : 'Others', others)}

    </div >
  );
};

export default Publications;
